import { ChoiceGroup, ComboBox, DatePicker, DayOfWeek, DefaultButton, IChoiceGroupOption, IComboBoxOption, IContextualMenuItem, Panel, PanelType, Pivot, PivotItem, PrimaryButton, SelectionMode, TextField } from "@fluentui/react";
import { isNullOrEmpty } from '@ioip/core/lib';
import { GenericDataTableComponent } from 'ioip-base/lib/common';
import React from 'react';
import { defaultAnswerEntidadAdscrita, IAnswerEntidadAdscrita } from '../../../classes/entidades-adscritas/answer-entidad-adscrita';
import { defaultCloserEntidadAdscrita, ICloserEntidadAdscrita } from '../../../classes/entidades-adscritas/closer-entidad-adscrita';
import { IRadicadoEntradaExtended } from '../../../classes/radicado-entrada-extended';
import { Sede } from '../../../classes/shared';
import { DatePickerStrings, fileToBase64, IDocumento, onFormatDate, showConfirmation, showError } from '../../../ioip/sdk/base';
import { DropZoneComponent } from '../../../ioip/sdk/components';
import { PqrWebService } from '../../../services/services';
import { MyPendingWorksComponentMode } from './my-pending-works-mode.enum';
import { IMyPendingWorksComponentProps } from './my-pending-works.props';
import { defaultMyPendingWorksComponentState, IMyPendingWorksComponentState } from './my-pending-works.state';

export class MyPendingWorksComponent extends React.Component<IMyPendingWorksComponentProps, IMyPendingWorksComponentState> {

  private _pqrWebService: PqrWebService;

  constructor(props: any) {
    super(props);
    this.state = defaultMyPendingWorksComponentState();
    this._pqrWebService = new PqrWebService();
  }

  public async componentDidMount(): Promise<void> {
    try {
      const parameter = Sede.Shared.Context.FechaConsultaSolicitudes;

      if (!isNullOrEmpty(parameter) && parameter !== '-') {
        const fecha: string = parameter.split(',', 2)[ 0 ];
        const url: string = parameter.split(',', 2)[ 1 ];
        this.setState({
          ...this.state,
          redirectConsultRequest: {
            fecha,
            url,
            show: true
          },
        });
      }

      let camposParametrizable = await this._pqrWebService.getParameterAsync('Sede_Electronica', 'EstadoLineaHonor');
      let habilitarEstadoEntidadAdscita = await this._pqrWebService.getParameterAsync('Sede_Electronica', 'EstadoHonorEntidadAdscrita');
      let idUsuario = await this._pqrWebService.getParameterAsync('Sede_Electronica', 'SuperUsuarioEntidadAdscrita');

      const result = 184000000;

      this.setState({
        ...this.state,
        maxLengthFile: result,
        EstadoLineaHonor: camposParametrizable,
        HabilitarEstadoEntidadAdscita: habilitarEstadoEntidadAdscita,
        IdUsuario: idUsuario.Value
      });
    } catch (error) {
      alert(error.toString());
    }
  }
  render(): JSX.Element {
    return (
      <div className=''>
        <div className='card'>
          <GenericDataTableComponent
            refreshOnInit={true}
            allowSearch={true}
            primaryKey='IdContacto'
            service={this._pqrWebService as any}
            paginationMethodName={this.getMethod()}
            columnsAllowedToOrder={[]}
            selectionMode={SelectionMode.multiple}
            columns={this.state.columns}
            title={'Mis respuestas pendientes'}
            searchTooltip='Filtrar tareas pendientes'
            commandBarItems={this.state.commandBar}
            onSelectedRow={this._onSelectedRow.bind(this)}
          />
          {this.state.ShowPanelEnviarRespuesta &&
            <Panel
              isOpen={this.state.ShowPanelEnviarRespuesta}
              type={PanelType.large}
              headerText={'Enviar una respuesta para el RE # ' + this.state.SelectedItems[ 0 ].NumeroRadicado}
              hasCloseButton={false}
              isFooterAtBottom={true}
              onRenderFooterContent={() =>
                <div>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
                      <PrimaryButton text='Enviar respuesta' primary={true} onClick={this._EnviarRespuesta.bind(this)} />
                      <span>&nbsp;&nbsp;</span>
                      <DefaultButton text='Cancelar' primary={false} onClick={this._clean.bind(this)} />
                    </div>
                  </div>
                </div>}
              closeButtonAriaLabel='Cerrar'>
              <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm6'>
                  <TextField
                    label='Trámite'
                    value={this.state.SelectedItems[ 0 ].Tramite}
                    readOnly={true}
                    disabled={true}
                  />
                </div>

                <div className='ms-Grid-col ms-u-sm6'>
                  <TextField
                    label='Fecha creación:'
                    value={this.state.SelectedItems[ 0 ].FechaCreacionString}
                    readOnly={true}
                    disabled={true}
                  />
                </div>

                <div className='ms-Grid-col ms-u-sm12'>
                  <TextField
                    label='Asunto:'
                    value={this.state.SelectedItems[ 0 ].Asunto}
                    readOnly={true}
                    multiline={true}
                    disabled={true}
                  />
                </div>

                <div className='ms-Grid-col ms-u-sm12'>
                  <TextField
                    label='Escriba las observaciones de su respuesta:'
                    value={this.state.Observaciones}
                    readOnly={false}
                    multiline={true}
                    disabled={false}
                    required={true}
                    errorMessage={this.state.errors[ 'Observaciones' ]}
                    onChange={this._changeModelTextField.bind(this, 'Observaciones')}
                    maxLength={512}

                  />
                </div>
                {
                  this.procesarCampoParametrizable()
                }
                <div className='ms-Grid-col ms-sm12 ms-md6 ms-lg12'>
                  <ChoiceGroup
                    defaultSelectedKey='0'
                    selectedKey={this.state.RespuestaDefinitiva === true ? '1' : '0'}
                    options={this.state.opcionesRespuestaDefinitiva}
                    onChange={this._onChangeOpcionPreferenciaRespuesta.bind(this)}
                    label={'Tipo respuesta'}
                  />
                </div>
                <div className='ms-Grid-row'>
                  <div className='ms-Grid-col ms-u-sm6'>
                    <TextField
                      label='Número documento'
                      value={this.state.NumeroDocumento}
                      required={true}
                      errorMessage={this.state.errors[ 'NumeroDocumento' ]}
                      onChange={this._changeModelTextField.bind(this, 'NumeroDocumento')}
                      disabled={false}
                    />
                  </div>

                  <div className='ms-Grid-col ms-u-sm6'>
                    <DatePicker
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DatePickerStrings}
                      label='Fecha del documento'
                      formatDate={onFormatDate}
                      onSelectDate={this._OnChangeModelDate.bind(this, 'FechaEnvio')}
                      value={this.state.FechaEnvio}
                      allowTextInput={true}
                    />
                  </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
                  <Pivot>
                    <PivotItem linkText='Documento principal'>
                      <DropZoneComponent
                        onAllowRemove={item => item.IdDocumentoRadicadoEntrada <= 0}
                        items={this.state.DocumentoPrincipal}
                        maxLength={this.state.maxLengthFile}
                        multiple={false}
                        useDefaultExtensions={false}
                        onRemove={this._onRemoveDocumentoPrincipal.bind(this)}
                        onChange={this._onChangeDocumentoPrincipal.bind(this)}
                        allowedExtensions={Sede.Shared.Context.AllowedExtensions}
                      />
                    </PivotItem>
                  </Pivot>
                </div>
                <small style={{ color: 'red' }}> {this.state.errors[ 'DocumentoPrincipal' ]}</small>

                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
                  <Pivot>
                    <PivotItem linkText='Anexos'>
                      <DropZoneComponent
                        onAllowRemove={item => item.IdDocumentoRadicadoEntrada <= 0}
                        items={this.state.Anexos}
                        maxLength={this.state.maxLengthFile}
                        multiple={true}
                        useDefaultExtensions={false}
                        onRemove={this._onRemoveAnexo.bind(this)}
                        onChange={this._onChangeAnexos.bind(this)}
                        allowedExtensions={Sede.Shared.Context.AllowedExtensions}
                      />
                    </PivotItem>
                  </Pivot>
                </div>
              </div>
            </Panel>
          }
          {this.state.ShowPanelDevolverPqr &&
            <Panel
              isOpen={this.state.ShowPanelDevolverPqr}
              type={PanelType.medium}
              headerText={'Devolver PQR'}
              hasCloseButton={false}
              isFooterAtBottom={true}
              onRenderFooterContent={() =>
                <div>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
                      <PrimaryButton text='Devolver' primary={true} onClick={this._DevolverPqr.bind(this)} />
                      <span>&nbsp;&nbsp;</span>
                      <DefaultButton text='Cancelar' primary={false} onClick={this._clean.bind(this)} />
                    </div>
                  </div>
                </div>}
              closeButtonAriaLabel='Cerrar'>
              <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12'>
                  <TextField
                    label='Escriba una observación:'
                    value={this.state.ObservacionesDevolver}
                    readOnly={false}
                    multiline={true}
                    disabled={false}
                    required={true}
                    errorMessage={this.state.errors[ 'ObservacionesDevolver' ]}
                    onChange={this._changeModelTextField.bind(this, 'ObservacionesDevolver')}
                    maxLength={512}
                  />
                </div>
              </div>
            </Panel>
          }
          {this.state.ShowPanelCerrarRespuestas &&
            <Panel
              isOpen={this.state.ShowPanelCerrarRespuestas}
              type={PanelType.medium}
              headerText={'Cerrar respuesta de Entidades Adscritas'}
              hasCloseButton={false}
              isFooterAtBottom={true}
              onRenderFooterContent={() =>
                <div>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
                      <PrimaryButton text='Cerrar' primary={true} onClick={this._CerrarRespuesta.bind(this)} />
                      <span>&nbsp;&nbsp;</span>
                      <DefaultButton text='Cancelar' primary={false} onClick={this._clean.bind(this)} />
                    </div>
                  </div>
                </div>}
              closeButtonAriaLabel='Cerrar'>
              <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12'>
                  <TextField
                    label='Escriba una observación:'
                    value={this.state.ObservacionesCierre}
                    readOnly={false}
                    multiline={true}
                    disabled={false}
                    required={true}
                    errorMessage={this.state.errors[ 'ObservacionesCierre' ]}
                    onChange={this._changeModelTextField.bind(this, 'ObservacionesCierre')}
                    maxLength={512}
                  />
                </div>

                <div className='ms-Grid-col ms-sm12 ms-md6 ms-lg12'>
                  <ChoiceGroup
                    defaultSelectedKey='0'
                    selectedKey={this.state.RespuestaDefinitiva === true ? '1' : '0'}
                    options={this.state.opcionesRespuestaDefinitiva}
                    onChange={this._onChangeOpcionPreferenciaRespuesta.bind(this)}
                    label={'Tipo respuesta'}
                  />
                </div>
                <div className='ms-Grid-row'>
                  <div className='ms-Grid-col ms-u-sm6'>
                    <TextField
                      label='Número documento'
                      value={this.state.NumeroDocumento}
                      required={false}
                      errorMessage={this.state.errors[ 'NumeroDocumento' ]}
                      onChange={this._changeModelTextField.bind(this, 'NumeroDocumento')}
                      disabled={false}
                    />
                  </div>

                  <div className='ms-Grid-col ms-u-sm6'>
                    <DatePicker
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DatePickerStrings}
                      label='Fecha del documento'
                      formatDate={onFormatDate}
                      onSelectDate={this._OnChangeModelDate.bind(this, 'FechaEnvio')}
                      value={this.state.FechaEnvio}
                      allowTextInput={true}
                    />
                  </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
                  <Pivot>
                    <PivotItem linkText='Documento principal *'>
                      <DropZoneComponent
                        onAllowRemove={item => item.IdDocumentoRadicadoEntrada <= 0}
                        items={this.state.DocumentoPrincipal}
                        maxLength={this.state.maxLengthFile}
                        multiple={false}
                        useDefaultExtensions={false}
                        onRemove={this._onRemoveDocumentoPrincipal.bind(this)}
                        onChange={this._onChangeDocumentoPrincipal.bind(this)}
                        allowedExtensions={Sede.Shared.Context.AllowedExtensions}
                      />
                    </PivotItem>
                  </Pivot>
                </div>

                <small style={{ color: 'red' }}> {this.state.errors[ 'DocumentoPrincipal' ]}</small>

                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
                  <Pivot>
                    <PivotItem linkText='Anexos'>
                      <DropZoneComponent
                        onAllowRemove={item => item.IdDocumentoRadicadoEntrada <= 0}
                        items={this.state.Anexos}
                        maxLength={this.state.maxLengthFile}
                        multiple={true}
                        useDefaultExtensions={false}
                        onRemove={this._onRemoveAnexo.bind(this)}
                        onChange={this._onChangeAnexos.bind(this)}
                        allowedExtensions={Sede.Shared.Context.AllowedExtensions}
                      />
                    </PivotItem>
                  </Pivot>
                </div>

              </div>
            </Panel>
          }
        </div>

        <div className='row'>
          <div className='col' style={{ textAlign: 'right', paddingTop: '15px' }}>
            <DefaultButton
              text='Volver a inicio'
              href='#/home'
            />
          </div>
        </div>
      </div >
    );
  }

  private getMethod(): string {
    var method: string;

    if (this.props.mode === MyPendingWorksComponentMode.MyPendingWorksComponentMode) {
      method = 'getPaginatePending';
    }

    return method;
  }

  private async _onSelectedRow(rows: IRadicadoEntradaExtended[]) {

    if (rows.length > 0) {

      if (rows.length >= 1) {
        this.setState({
          commandBar: await this._buildCommandBar(rows),
          IdRadicadoEntradaSelected: rows[ 0 ].IdRadicadoEntrada,
          SelectedItems: rows,
        });
      }
    } else {
      this.setState({
        commandBar: await this._buildCommandBar([]),
        IdRadicadoEntradaSelected: 0,
        SelectedItems: []
      });
    }
  }

  private async _buildCommandBar(selectedItems: IRadicadoEntradaExtended[]): Promise<IContextualMenuItem[]> {
    const commandBar: IContextualMenuItem[] = [];
    commandBar.push(
      {
        key: 'Exportar a Excel',
        name: 'Exportar a Excel',
        iconProps: { iconName: 'MergeDuplicate' },
        onClick: () => {
          new Promise<void>(async (resolve) => {
            resolve(await this._exportToExcel())
          })
        }
      }
    );

    if (selectedItems.length == 1) {
      if (sessionStorage.getItem('ioip.pqr-web.session.email').toLowerCase() == selectedItems[ 0 ].CorreoElectronicoContacto.toLowerCase()) {
        commandBar.push(
          {
            key: 'EnviarRespuesta',
            name: 'Enviar Respuesta',
            iconProps: { iconName: 'send' },
            onClick: () => {
              this.setState({
                ShowPanelEnviarRespuesta: true
              });
            }
          }
        );
        commandBar.push(
          {
            key: 'DevolverPqr',
            name: 'Devolver PQR',
            iconProps: { iconName: 'NavigateBack' },
            onClick: () => {
              this.setState({
                ShowPanelDevolverPqr: true
              });
            }
          }
        );
      }
    }

    if (selectedItems.length >= 1) {
      if (this.state.IdUsuario == sessionStorage.getItem('ioip.pqr-web.session.idcontacto')) {
        commandBar.push(
          {
            key: 'Cerrar Registro',
            name: 'Cerrar Registro',
            iconProps: { iconName: 'ClosePaneMirrored' },
            onClick: () => {
              this.setState({
                ShowPanelCerrarRespuestas: true
              });
            }
          }
        );
      }
    }

    return commandBar;
  }

  private async _exportToExcel(): Promise<void> {
    try {
      this._pqrWebService.exportMyPendingWorksAsync();
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }


  private async _clean(): Promise<void> {
    this.setState({
      ShowPanelEnviarRespuesta: false,
      ShowPanelCerrarRespuestas: false,
      IdRadicadoEntradaSelected: 0,
      Anexos: [],
      DocumentoPrincipal: [],
      Observaciones: '',
      ObservacionesCierre: '',
      ObservacionesDevolver: '',
      RespuestaDefinitiva: false,
      errors: {}
    }, () => {
      this.setState({
        ShowPanelEnviarRespuesta: false,
        ShowPanelCerrarRespuestas: false,
        ShowPanelDevolverPqr: false,
      });
    });
  }


  protected _changeModelCheckBox(property: string, ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      ...(this.state as any),
      [ property ]: checked
    });
  }

  private async _onRemoveAnexo(item: any): Promise<void> {
    const items = this.state.DocumentoPrincipal.filter(o => o.NombreArchivo !== item.Name);
    this.setState({
      ...this.state,
      Anexos: items

    });
  }

  private async _onChangeAnexos(documents: IDocumento[]): Promise<void> {
    this.setState({
      ...this.state,
      Anexos: documents,

    });
  }


  private async _onRemoveDocumentoPrincipal(item: any): Promise<void> {
    const items = this.state.DocumentoPrincipal.filter(o => o.NombreArchivo !== item.Name);
    this.setState({
      ...this.state,
      DocumentoPrincipal: items

    });
  }

  private async _onChangeDocumentoPrincipal(documents: IDocumento[]): Promise<void> {
    this.setState({
      ...this.state,
      DocumentoPrincipal: documents
    });
  }

  private async _onChangeLineaHonorComboBox(property: string, event: any, option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): Promise<void> {
    this.setState({
      ...this.state,
      IdEstadoLineaHonor: Number(option.key),
      [ property ]: option.text
    });
  }

  public validateFields(tipo: string): boolean {

    try {
      let errors = {};
      let hasError = false;

      if (tipo == "Responder") {
        if (this.state.Observaciones.trim().length <= 0) {
          errors[ 'Observaciones' ] = 'Campo requerido';
          hasError = true;
        }
        else {
          errors[ 'Observaciones' ] = '';
        }

        if (this.state.DocumentoPrincipal === undefined || this.state.DocumentoPrincipal === null) {
          errors[ 'DocumentoPrincipal' ] = 'El documento principal es obligatorio';
          hasError = true;
          showError('El documento principal es requerido.');
        }
        else {
          if (this.state.DocumentoPrincipal.length <= 0) {
            errors[ 'DocumentoPrincipal' ] = 'El documento principal es obligatorio';
            hasError = true;
            showError('El documento principal es requerido.');
          }
          else {
            errors[ 'DocumentoPrincipal' ] = '';
          }
        }

        if (this.state.NumeroDocumento.trim().length <= 0) {
          errors[ 'NumeroDocumento' ] = 'Campo requerido';
          hasError = true;
        }
        else {
          errors[ 'NumeroDocumento' ] = '';
        }

        let idContacto = sessionStorage.getItem('ioip.pqr-web.session.idcontacto');
        let entidades = this.state.HabilitarEstadoEntidadAdscita.Value.split(',');

        if (entidades.filter(name => name.includes(idContacto)).length > 0) {
          if (this.state.IdEstadoLineaHonor == 0) {
            errors[ 'NombreEstadoLineaHonor' ] = 'Campo requerido';
            hasError = true;
          }
        }
      }
      else {
        if (tipo == "Devolver") {
          if (this.state.ObservacionesDevolver.trim().length <= 0) {
            errors[ 'ObservacionesDevolver' ] = 'Campo requerido';
            hasError = true;
          }
          else {
            errors[ 'ObservacionesDevolver' ] = '';
          }
        }
        else {
          if (this.state.ObservacionesCierre.trim().length <= 0) {
            errors[ 'ObservacionesCierre' ] = 'Campo requerido';
            hasError = true;
          }
          else {
            errors[ 'ObservacionesCierre' ] = '';
          }

          if (this.state.DocumentoPrincipal === undefined || this.state.DocumentoPrincipal === null) {
            errors[ 'DocumentoPrincipal' ] = 'El documento principal es obligatorio';
            hasError = true;
            showError('El documento principal es requerido.');
          }
          else {
            if (this.state.DocumentoPrincipal.length <= 0) {
              errors[ 'DocumentoPrincipal' ] = 'El documento principal es obligatorio';
              hasError = true;
              showError('El documento principal es requerido.');
            }
            else {
              errors[ 'DocumentoPrincipal' ] = '';
            }
          }
        }
      }
      this.setState({
        errors
      }, () => { });

      return hasError;

    }
    catch (error) {
      showError(error.toString());
      console.log(error);
    }
  }

  private async _EnviarRespuesta() {

    if (this.validateFields("Responder") === false) {
      showConfirmation('Enviar respuesta', '¿Está seguro que desea enviar la respuesta?', async () => {
        try {
          let respuesta: IAnswerEntidadAdscrita = defaultAnswerEntidadAdscrita();
          respuesta.IdRadicadoEntrada = this.state.SelectedItems[ 0 ].IdRadicadoEntrada;
          respuesta.Observaciones = this.state.Observaciones;
          respuesta.RespuestaDefinitiva = this.state.RespuestaDefinitiva;
          respuesta.DocumentoPrincipal = await fileToBase64(this.state.DocumentoPrincipal[ 0 ].Archivo);

          respuesta.Autor = this.state.SelectedItems[ 0 ].CorreoElectronicoContacto;
          respuesta.EstadoLineaHonor = this.state.NombreEstadoLineaHonor;
          respuesta.NumeroDocumento = this.state.NumeroDocumento;
          respuesta.FechaEnvio = this.state.FechaEnvio;

          for (let i = 0; i < this.state.Anexos.length; i++) {
            const element = this.state.Anexos[ i ];
            element.Archivo64 = await fileToBase64(element.Archivo);
            respuesta.Anexos.push(element.Archivo64);
            element.Archivo = undefined;
          }

          let result = await this._pqrWebService.SaveAnswerFromEntidadAdscritaAsync(respuesta);

          this.setState({
            ...this.state,
            ShowPanelEnviarRespuesta: false

          }, () => { window.location.href = '#/sign-in/answer-rs' });



          if (result) {
            alert('Respuesta enviada correctamente.');
          }
          else {
            alert('Error guardando la respuesta.');
          }

        } catch (exexption) {
          const ex: any = exexption;
          alert(ex.exceptionMessage || ex.ExceptionMessage);
        }
      });
    }
  }

  private async _DevolverPqr() {
    if (this.validateFields("Devolver") === false) {
      showConfirmation('Enviar respuesta', '¿Está seguro que desea devolver el PQR?', async () => {
        try {
          let result = await this._pqrWebService.devolverPqrAsync(this.state.SelectedItems.map(o => o.IdRadicadoSalida),
            this.state.ObservacionesDevolver);

          this.setState({
            ...this.state,
            ShowPanelDevolverPqr: false
          }, () => { window.location.href = '#/sign-in/answer-rs' });


          if (result) {
            alert('PQR devuelto correctamente.');
          }
          else {
            alert('Error devolviendo PQR.');
          }

        } catch (ex) {
          alert(ex.toString());
        }
      });
    }
  }

  private async _CerrarRespuesta() {
    if (this.validateFields("Cerrar") === false) {
      showConfirmation('Enviar respuesta', '¿Está seguro que desea cerrar las respuestas?', async () => {
        try {

          let respuesta: ICloserEntidadAdscrita = defaultCloserEntidadAdscrita();
          respuesta.IdRadicados = this.state.SelectedItems.map(o => o.IdRadicadoEntrada);
          respuesta.Observaciones = this.state.ObservacionesCierre;
          respuesta.RespuestaDefinitiva = this.state.RespuestaDefinitiva;
          respuesta.DocumentoPrincipal = await fileToBase64(this.state.DocumentoPrincipal[ 0 ].Archivo);

          respuesta.Autor = this.state.SelectedItems[ 0 ].CorreoElectronicoContacto;
          respuesta.EstadoLineaHonor = this.state.NombreEstadoLineaHonor;
          respuesta.NumeroDocumento = this.state.NumeroDocumento;
          respuesta.FechaEnvio = this.state.FechaEnvio;

          for (let i = 0; i < this.state.Anexos.length; i++) {
            const element = this.state.Anexos[ i ];
            element.Archivo64 = await fileToBase64(element.Archivo);
            respuesta.Anexos.push(element.Archivo64);
            element.Archivo = undefined;
          }

          let result = await this._pqrWebService.closeEntidadAdscritaBySuperUserAsync(respuesta);

          this.setState({
            ...this.state,
            ShowPanelCerrarRespuestas: false
          }, () => { window.location.href = '#/sign-in/answer-rs' });


          if (result == 'true') {
            alert('Peticiones cerradas correctamente.');
          }
          else {
            alert('Error cerrando alguna solicitud.');
          }

        } catch (ex) {
          alert(ex.toString());
        }
      });
    }
  }

  protected _changeModelTextField(property: string, _: any, value: string) {
    this.setState({
      ...(this.state as any),
      [ property ]: value

    });
  }


  private _onChangeOpcionPreferenciaRespuesta(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({

      ...this.state,
      RespuestaDefinitiva: option.key === '0' ? false : true


    });
  }

  protected _OnChangeModelDate(property: string, date: Date | null | undefined): void {
    this.setState({
      ...(this.state as any),
      [ property ]: date
    });
  };

  private procesarCampoParametrizable() {
    let idContacto = sessionStorage.getItem('ioip.pqr-web.session.idcontacto');
    let entidades = this.state.HabilitarEstadoEntidadAdscita.Value.split(',');

    if (entidades.filter(name => name.includes(idContacto)).length > 0) {
      if (this.state.EstadoLineaHonor != undefined) {

        const tmp = JSON.stringify(this.state.EstadoLineaHonor.Value);
        const tmp2 = JSON.parse(tmp);
        const tmp3 = JSON.parse(tmp2);

        const option: IComboBoxOption[] = tmp3.Option.map(o => ({ key: o.Key, text: o.Name }));

        if (tmp3.TipoCampo == "ComboBox") {

          if (tmp3.Requerido == "true")
            this.setState({ IdEstadoLineaHonor: 0 });

          return <div className='ms-Grid-col ms-sm12 ms-md6 ms-lg12'>
            <ComboBox
              selectedKey={this.state.IdEstadoLineaHonor}
              label={tmp3.Label}
              useComboBoxAsMenuWidth={true}
              autoComplete='on'
              options={option}
              required={tmp3.Requerido}
              errorMessage={this.state.errors[ 'NombreEstadoLineaHonor' ]}
              onChange={this._onChangeLineaHonorComboBox.bind(this, 'NombreEstadoLineaHonor')}
            />
          </div>
        }
      }
    }
  }

}